<tiime-dialog (cancel)="cancel()">
  <span mat-dialog-title>Ajouter un dossier</span>
  <mat-dialog-content class="dialog-content" mat-dialog-content>
    @if (isLoading()) {
      <mat-progress-spinner diameter="50" color="primary" mode="indeterminate"></mat-progress-spinner>
    } @else {
      @if (canCreateCompany()) {
        <div class="choice-card-container flex row space-evenly">
          <div
            class="choice-card"
            (click)="openCreateCompanyDialog('Legal')"
            (keydown)="openCreateCompanyDialog('Legal')"
            data-cy="legal-create-company"
          >
            <span class="product">
              <img src="assets/logo_company_creation.svg" alt="logo tiime legal" />
              Tiime Legal
            </span>
            <span class="choice-action">Créer une société</span>
          </div>
          <div
            class="choice-card"
            (click)="openCreateCompanyDialog('Expert')"
            (keydown)="openCreateCompanyDialog('Expert')"
          >
            <span class="product">
              <img src="assets/logo_expert_nav.svg" alt="logo tiime expert" />
              Tiime Expert
            </span>
            <span class="choice-action">Ajouter un dossier</span>
          </div>
          <div
            class="choice-card"
            (click)="openCreateCompanyDialog('CapitalDeposit')"
            (keydown)="openCreateCompanyDialog('CapitalDeposit')"
          >
            <span class="product">
              <img src="assets/illu_tiime_business_card.svg" alt="logo compte pro tiime" />
              Compte pro Tiime
            </span>
            <span class="choice-action">Dépôt de capital</span>
          </div>
        </div>
        @if (canCreateDemoCompany()) {
          <span
            class="create-demo-company-link"
            (click)="openCreateDemoCompanyDialog()"
            (keydown)="openCreateDemoCompanyDialog()"
          >
            Créer une société (démo)
          </span>
        }
      } @else {
        <tiime-alert warn>
          La création de dossier depuis l’interface Tiime n’est pas autorisée pour vos groupes
        </tiime-alert>
      }
    }
  </mat-dialog-content>
</tiime-dialog>
